module.exports = __webpack_public_path__ + "static/media/success.2c5f375c.svg";